import { BrowserCache } from '@cache/browser';

export const HybridCache = BrowserCache;
